import React from "react";
import dateFormat from "dateformat";
import styles from "./styles/PostMeta.module.scss";

function formattedDate(date) {

	return dateFormat(date, "mmmm d, yyyy");

}


const DateComponent = ({date}) => {

	return (

		<h5 className={styles.DateBlock}>
			{this.formattedDate(date)}
		</h5>

	);

};


const PostMetaComponent = ({date,author}) => {

	return (

		<h5 className={styles.PostMetaBlock}>
			{formattedDate(date)} by {author}
		</h5>

	);

};

export {

	PostMetaComponent,
	DateComponent

};
